
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  OrganizationClientLegalEntitiesVerificationRequestStatusResource,
  VerificationRequestCreationResource,
} from '../models';
import {
    OrganizationClientLegalEntitiesVerificationRequestStatusResourceFromJSON,
    OrganizationClientLegalEntitiesVerificationRequestStatusResourceToJSON,
    VerificationRequestCreationResourceFromJSON,
    VerificationRequestCreationResourceToJSON,
} from '../models';

export interface GetOrganizationLegalEntitiesVerificationRequestStatusRequest {
    organizationId: string;
    maxRequestableLegalEntities?: number;
}

export interface RequestOrganizationLegalEntitiesVerificationRequest {
    organizationId: string;
    verificationRequestCreationResource: VerificationRequestCreationResource;
}

/**
 * 
 */
export class OrganizationVerificationRequestApi extends runtime.BaseAPI {

    /**
     * Get manual verification request status for client legal entities of an organization
          */
    async getOrganizationLegalEntitiesVerificationRequestStatusRaw(requestParameters: GetOrganizationLegalEntitiesVerificationRequestStatusRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<OrganizationClientLegalEntitiesVerificationRequestStatusResource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getOrganizationLegalEntitiesVerificationRequestStatus().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['maxRequestableLegalEntities'] != null) {
            queryParameters['maxRequestableLegalEntities'] = requestParameters['maxRequestableLegalEntities'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<OrganizationClientLegalEntitiesVerificationRequestStatusResource>({
            path: `/compliance/api/organizations/{organizationId}/legal-entities/verification-request-status`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=OrganizationClientLegalEntitiesVerificationRequestStatusResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get manual verification request status for client legal entities of an organization
          */
    async getOrganizationLegalEntitiesVerificationRequestStatus(requestParameters: GetOrganizationLegalEntitiesVerificationRequestStatusRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<OrganizationClientLegalEntitiesVerificationRequestStatusResource> {
        const response = await this.getOrganizationLegalEntitiesVerificationRequestStatusRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Request manual verification for eligible client legal entities of an organization
          */
    async requestOrganizationLegalEntitiesVerificationRaw(requestParameters: RequestOrganizationLegalEntitiesVerificationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling requestOrganizationLegalEntitiesVerification().'
            );
        }

        if (requestParameters['verificationRequestCreationResource'] == null) {
            throw new runtime.RequiredError(
                'verificationRequestCreationResource',
                'Required parameter "verificationRequestCreationResource" was null or undefined when calling requestOrganizationLegalEntitiesVerification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/organizations/{organizationId}/legal-entities/verification-requests`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VerificationRequestCreationResourceToJSON(requestParameters['verificationRequestCreationResource']),
        }, initOverrides);

        return response;
    }

    /**
     * Request manual verification for eligible client legal entities of an organization
          */
    async requestOrganizationLegalEntitiesVerification(requestParameters: RequestOrganizationLegalEntitiesVerificationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.requestOrganizationLegalEntitiesVerificationRaw(requestParameters, initOverrides);
    }

}
